import WorkIm from '../assets/projects/workImg.jpeg'
import RealEst from '../assets/projects/realestate.jpg'

export const data=[
    {
        id:1,
        name:"AI Consultation Services",
        image:WorkIm,
        github:"",
        live:"",
    },
    {
        id:2,
        name:"Autonomous AI Bots Development",
        image:RealEst,
        github:"",
        live:"",
    },
    {
        id:3,
        name:"Software Development",
        image:WorkIm,
        github:"",
        live:"",
    },
    

]